export default "__VITE_ASSET__DDOPIe1A__"